import { Injectable, ɵɵdefineInjectable } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EventBusService {
    constructor() {
        this.eventsHolder = {};
    }
    /**
     * @param {?} event
     * @return {?}
     */
    addEventListener(event) {
        /** @type {?} */
        let events = this.eventsHolder[event.name];
        if (!events) {
            events = [];
        }
        events.push(event);
        this.eventsHolder[event.name] = events;
        return event;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    removeEventListener(event) {
        /** @type {?} */
        let events = this.eventsHolder[event.name];
        if (!events) {
            events = [];
        }
        /** @type {?} */
        const index = events.indexOf(event);
        if (index == -1)
            return;
        events.splice(index, 1);
    }
    /**
     * @template T
     * @param {?} eventName
     * @param {?=} payload
     * @return {?}
     */
    triggerEvent(eventName, payload = null) {
        /** @type {?} */
        let events = this.eventsHolder[eventName];
        if (events) {
            events.forEach((/**
             * @param {?} e
             * @return {?}
             */
            e => {
                this.execute(e.callback, payload);
            }));
        }
    }
    /**
     * @private
     * @template T
     * @param {?} action
     * @param {?} payload
     * @return {?}
     */
    execute(action, payload) {
        setTimeout((/**
         * @return {?}
         */
        () => {
            action(payload);
        }), 0);
    }
}
EventBusService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */ EventBusService.ngInjectableDef = ɵɵdefineInjectable({ factory: function EventBusService_Factory() { return new EventBusService(); }, token: EventBusService, providedIn: "root" });

export { EventBusService };
